export const GET_DIMENSIONS_DATA_WATCHER = "app/ClimateMeasurement/GET_DIMENSIONS_DATA_WATCHER"
export const GET_DIMENSIONS_DATA_SUCCESS = "app/ClimateMeasurement/GET_DIMENSIONS_DATA_SUCCESS"  
export const GET_DIMENSIONS_DATA_FAILED = "app/ClimateMeasurement/GET_DIMENSIONS_DATA_FAILED"